// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-size: 16px;
  text-align: center;
  border-radius: 8px;
  height: var(--button-height);
  width: 100%;
  padding: 0px 15px 0px 15px;
  cursor: pointer;
}
.button__type1 {
  background: #ffffff;
  color: #666666;
  border: 1px solid #e1e1e1;
}
.button__type2 {
  background: #075453;
  color: #ffffff;
  border: none;
  font-weight: 400;
}
.button__type3 {
  background: #49ae9e;
  color: #ffffff;
  border: none;
}
.button__type4 {
  color: #49ae9e;
  border: 1px solid #d6e7e4;
  background: #e5f4f2;
  border-radius: 8px;
  font-weight: 400;
}
.button__type5 {
  border: 1px solid #49ae9e;
  background: #ffffff;
  border-radius: 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #49ae9e;
}
.button__type6 {
  background: #ffe338;
  border-radius: 8px;
  border: none;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
}
.button__type7 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #505054;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
}
.button__type8 {
  border: 1px solid #e1e1e1;
  background: #ffffff;
  border-radius: 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #505054;
}
.button__type9 {
  background: #333333;
  color: #ffffff;
  border: none;
  font-weight: 400;
}
.button__type10 {
  border: 1px solid #c1c1c1;
  background: #c1c1c1;
  border-radius: 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #e1e1e1;
}
.button__type11 {
  background: #ffffff;
  color: #666666;
  border: 1px solid #e1e1e1;
  padding-top: 2px;
}
.button__type12 {
  border: 1px solid #49ae9e;
  background: #ffffff;
  border-radius: 8px;
  padding-top: 2px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #49ae9e;
}
.button__type13 {
  border: none;
  background: #eff0f0;
  border-radius: 8px;
  padding-top: 2px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #505054;
}
.button__type14 {
  background: #e47c77;
  color: #ffffff;
  border: none;
  font-weight: 400;
}
.button__type15 {
  background: #000000;
  color: #ffffff;
  border: none;
  font-weight: 400;
}
.button__icon {
  display: flex;
  align-items: center;
}
.button__icon__label {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/common/button/button.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;AACJ;AACI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AACR;AAEI;EACI,mBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAAR;AAGI;EACI,mBAAA;EACA,cAAA;EACA,YAAA;AADR;AAII;EACI,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAFR;AAKI;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAJR;AAOI;EACI,mBAAA;EACA,kBAAA;EACA,YAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AANR;AASI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAPR;AAUI;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATR;AAYI;EACI,mBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAVR;AAaI;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAZR;AAeI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAbR;AAgBI;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAfR;AAkBI;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAjBR;AAoBI;EACI,mBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAlBR;AAqBI;EACI,mBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAnBR;AAsBI;EACI,aAAA;EACA,mBAAA;AApBR;AAsBQ;EACI,iBAAA;AApBZ","sourcesContent":[".button {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-size: 16px;\n    text-align: center;\n    border-radius: 8px;\n    height: var(--button-height);\n    width: 100%;\n    padding: 0px 15px 0px 15px;\n    cursor: pointer;\n\n    &__type1 {\n        background: #ffffff;\n        color: #666666;\n        border: 1px solid #e1e1e1;\n    }\n\n    &__type2 {\n        background: #075453;\n        color: #ffffff;\n        border: none;\n        font-weight: 400;\n    }\n\n    &__type3 {\n        background: #49ae9e;\n        color: #ffffff;\n        border: none;\n    }\n\n    &__type4 {\n        color: #49ae9e;\n        border: 1px solid #d6e7e4;\n        background: #e5f4f2;\n        border-radius: 8px;\n        font-weight: 400;\n    }\n\n    &__type5 {\n        border: 1px solid #49ae9e;\n        background: #ffffff;\n        border-radius: 8px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        color: #49ae9e;\n    }\n\n    &__type6 {\n        background: #ffe338;\n        border-radius: 8px;\n        border: none;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        text-align: center;\n    }\n\n    &__type7 {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        text-align: center;\n        color: #505054;\n        background: #ffffff;\n        border: 1px solid #e1e1e1;\n        border-radius: 6px;\n    }\n\n    &__type8 {\n        border: 1px solid #e1e1e1;\n        background: #ffffff;\n        border-radius: 8px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        color: #505054;\n    }\n\n    &__type9 {\n        background: #333333;\n        color: #ffffff;\n        border: none;\n        font-weight: 400;\n    }\n\n    &__type10 {\n        border: 1px solid #c1c1c1;\n        background: #c1c1c1;\n        border-radius: 8px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 22px;\n        text-align: center;\n        color: #e1e1e1;\n    }\n\n    &__type11 {\n        background: #ffffff;\n        color: #666666;\n        border: 1px solid #e1e1e1;\n        padding-top: 2px;\n    }\n\n    &__type12 {\n        border: 1px solid #49ae9e;\n        background: #ffffff;\n        border-radius: 8px;\n        padding-top: 2px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        color: #49ae9e;\n    }\n\n    &__type13 {\n        border: none;\n        background: #eff0f0;\n        border-radius: 8px;\n        padding-top: 2px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 22px;\n        text-align: center;\n        color: #505054;\n    }\n\n    &__type14 {\n        background: #e47c77;\n        color: #ffffff;\n        border: none;\n        font-weight: 400;\n    }\n\n    &__type15 {\n        background: #000000;\n        color: #ffffff;\n        border: none;\n        font-weight: 400;\n    }\n\n    &__icon {\n        display: flex;\n        align-items: center;\n\n        &__label {\n            margin-right: 5px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
